import { render, staticRenderFns } from "./rights-swipper.vue?vue&type=template&id=17342647&lang=pug&"
import script from "./rights-swipper.vue?vue&type=script&lang=js&"
export * from "./rights-swipper.vue?vue&type=script&lang=js&"
import style0 from "./rights-swipper.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports